import Cookies from 'js-cookie';
import { COOKIE_FOR_MOBILE_NAME } from '../constants';
/**
 * Determines if the current page is being rendered within the mobile application (WebView).
 *
 * If the cookies object contains this key "mobile" with value "true", then it is a mobile application.
 *
 * @returns true or false
 */
export const isOnMobileApp = () => Cookies.get(COOKIE_FOR_MOBILE_NAME) === 'true';
//# sourceMappingURL=mobile.js.map